import { render, staticRenderFns } from "./appMenuAdmin.vue?vue&type=template&id=dfee4b30&scoped=true"
import script from "./appMenuAdmin.vue?vue&type=script&lang=js"
export * from "./appMenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./appMenuAdmin.vue?vue&type=style&index=0&id=dfee4b30&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfee4b30",
  null
  
)

export default component.exports